import { useUserRealmId } from "@easybiz/component-shared";
import { formatMediaUrl } from "@easybiz/lib-shared-utils";
import { Badge, Image } from "antd";
import React from "react";

export default ({ width, photoId, count, onClick }) => {
  const realmId = useUserRealmId();

  return (
    <Badge count={count} showZero={false} offset={[-4, 4]}>
      <Image
        style={{ width: width, height: width }}
        fallback="/images/defualt-cloth.jpg"
        preview={false}
        src={photoId ? formatMediaUrl(photoId, realmId) : "/images/defualt-cloth.jpg"}
        onClick={onClick}
      />
    </Badge>
  );
};
